const els = {
    $section: () => $('[data-video-section]'),
    $popup: () => els.$section().find('[data-popup]'),
    $frame: () => els.$popup().find('[data-frame]'),
    $iframe: () => els.$popup().find('iframe'),
    $closeButton: () => els.$popup().find('[data-close]'),
    $clickout: () => els.$popup().find('[data-clickout]'),
};

export default els;

